import React from 'react'

export default function Gift() {
    
    const gift=JSON.parse(localStorage.getItem('gift'));
    
  return (
    <div className='bg-dwam'>
        <div className='bg-dwam border-t-2 border-yakam p-4'>
            <div className='space-y-2'>
                <p className='text-center text-shasham text-3xl  drop-shadow-md md:text-3xl'>خەڵاتی ئەمڕۆ</p>
                <div className='flex  justify-center mx-auto items-center bg-shasham rounded-3xl  w-fit flex-col '>
                    <img className='md:w-64 md:h-6w-64 w-30 h-30 bg-chwaram rounded-3xl shadow-xl backdrop-blur-md bg-opacity-20 object-contain' src={gift} alt='ddd' />
                    
                    
                    
                </div>
            </div>
        </div>
    </div>
  )
}
